import React, { useEffect, useState, useRef } from "react";

import ProgressOne from "../../Images/progressOne.svg";
import ProgressTwoGrey from "../../Images/progressTwoGrey.svg";
import ProgressThreeGrey from "../../Images/progressThreeGrey.svg";
import ProgressFourGrey from "../../Images/progressFourGrey.svg";
import ProgressFiveGrey from "../../Images/progressFiveGrey.svg";
import ProgressSixGrey from "../../Images/progressSixGrey.svg";

import ProgressTwoGreen from "../../Images/progressTwoGreen.svg";
import ProgressThreeGreen from "../../Images/progressThreeGreen.svg";
import ProgressFourGreen from "../../Images/progressFourGreen.svg";
import ProgressFiveGreen from "../../Images/progressFiveGreen.svg";
import ProgressSixGreen from "../../Images/progressSixGreen.svg";

// import ProgressFinalOne from "../../Images/progressOne.svg";
//last ones depend on step
import FinalProgressTwoGrey from "../../Images/troubleShooting/finalTwoGrey.svg";
import FinalProgressThreeGrey from "../../Images/troubleShooting/finalThreeGrey.svg";
import FinalProgressFourGrey from "../../Images/troubleShooting/finalFourGrey.svg";
import FinalProgressFiveGrey from "../../Images/troubleShooting/finalFiveGrey.svg";
import FinalProgressSixGrey from "../../Images/troubleShooting/finalSixGrey.svg";

import FinalProgressTwoGreen from "../../Images/troubleShooting/finalTwoGreen.svg";
import FinalProgressThreeGreen from "../../Images/troubleShooting/finalThreeGreen.svg";
import FinalProgressFourGreen from "../../Images/troubleShooting/finalFourGreen.svg";
import FinalProgressFiveGreen from "../../Images/troubleShooting/finalFiveGreen.svg";
import FinalProgressSixGreen from "../../Images/troubleShooting/finalSixGreen.svg";



import SectionOne from "../../CommonUtils/TroubleshootingSteps/SectionOne";
import SectionTwo from "../../CommonUtils/TroubleshootingSteps/SectionTwo";
import SectionThree from "../../CommonUtils/TroubleshootingSteps/SectionThree";
import SectionFour from "../../CommonUtils/TroubleshootingSteps/SectionFour";
import SectionFive from "../../CommonUtils/TroubleshootingSteps/SectionFive";
import SectionSix from "../../CommonUtils/TroubleshootingSteps/SectionSix";




const MessageA9T = (props) => {
    const {data ,scrollToBottom ,addMessages ,showMaximumChat} =props
    const [selectedOptions, setSelectedOptions] = useState([true, false, false, false, false, false, false]);
    const [toggleOption, setToggleOption] = useState({});
    const [maxStep, setMaxStep] = useState(1);

    const boxRef = useRef();
    const errorMessageContainerRef = useRef(null);

    useEffect(() => {
        const maxStepCount = countMaxSteps();
        setMaxStep(maxStepCount);
    }, [props.item]);

    // useEffect(()=>{
    //     scrollToBottom();
    // });

    useEffect(()=>{
        localStorage.setItem("ignoreError", JSON.stringify('Complete the Troubbleshooting flow'));
    },[]);

    useEffect(() => {
        if (errorMessageContainerRef.current) {
            errorMessageContainerRef.current.scrollBy({
                top: 50, // Scroll only 5px
                behavior: 'smooth', // Smooth scrolling effect
            });
        }
    }, [selectedOptions]);
    

    const countMaxSteps = () => {
        let maxStep = 0;
        Object.keys(data).forEach((key) => {
            if (key.startsWith("step_")) {
                const stepNumber = parseInt(key.split("_")[1], 10);
                if (!isNaN(stepNumber) && stepNumber > maxStep) {
                    maxStep = stepNumber;
                }
            }
        });
        return maxStep;
    };

    const getProgressOptions = (selectedOptions, maxStep) => {
        const progressComponents = [
            ProgressOne,
            { green: ProgressTwoGreen, grey: ProgressTwoGrey },
            { green: ProgressThreeGreen, grey: ProgressThreeGrey },
            { green: ProgressFourGreen, grey: ProgressFourGrey },
            { green: ProgressFiveGreen, grey: ProgressFiveGrey },
            { green: ProgressSixGreen, grey: ProgressSixGrey },
        ];

        const finalProgressComponents = {
            2: { green: FinalProgressTwoGreen, grey: FinalProgressTwoGrey },
            3: { green: FinalProgressThreeGreen, grey: FinalProgressThreeGrey },
            4: { green: FinalProgressFourGreen, grey: FinalProgressFourGrey },
            5: { green: FinalProgressFiveGreen, grey: FinalProgressFiveGrey },
            6: { green: FinalProgressSixGreen, grey: FinalProgressSixGrey },
        };

        const options = [ProgressOne];

        for (let i = 1; i < maxStep; i++) {
            if (i < maxStep - 1) {
                options.push(selectedOptions[i] ? progressComponents[i].green : progressComponents[i].grey);
            } else {
                options.push(selectedOptions[i] ? finalProgressComponents[maxStep].green : finalProgressComponents[maxStep].grey);
            }
        }

        return options;
    };

    const options = getProgressOptions(selectedOptions, maxStep);

    const handleButtonClick = (id, option, uncheck) => {
  
        setToggleOption((prevOptions) => ({
            ...prevOptions,
            [id]: option,
        }));

        if (uncheck && uncheck.value === false) {
            setSelectedOptions((prev) => prev.map((opt, idx) => idx <= id));
            setToggleOption((prevOptions) => {
                const newOptions = { ...prevOptions };
                for (let i = id + 1; i <= Object.keys(prevOptions).length; i++) {
                    newOptions[i] = "";
                }
                return newOptions;
            });
            return;
        }

        if (option === "yes" && data[`step_${id}_yes_next_steps`] !== "no") {
            setSelectedOptions((prev) => prev.map((opt, idx) => idx <= id));
        } else if (option === "no" && data[`step_${id}_no_next_steps`] !== "no") {
            setSelectedOptions((prev) => prev.map((opt, idx) => idx <= id));
        } else {
            setSelectedOptions((prev) => prev.map((opt, idx) => idx < id));

            if (option === "no") {
                setToggleOption((prevOptions) => ({
                    ...prevOptions,
                    [id]: "",
                }));
            }
        }
    };
    
    

    return (
        <div>
            <div ref={boxRef} className="box">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span className="error-head">Troubleshooting Steps</span>
                </div>
                <div className="error-container">
                    <div className="error-side-nav">
                        {options.map((option, index) => (
                            <img key={index} src={option} style={{ height: "clamp(32px, 4vw, 72px)", width: "clamp(16px, 4vw, 32px)" }} />
                        ))}
                    </div>
                    <div ref={errorMessageContainerRef}
                        className="error-message-container"
                        style={{
                            flexGrow: 1,
                            overflowY: 'auto',
                        }}>
                        <SectionOne
                            handleButtonClick={handleButtonClick}
                            setSelectedOptions={setSelectedOptions}
                            selectedOptions={selectedOptions}
                            toggleOption={toggleOption}
                            data={data}
                            addMessages={addMessages}
                            showMaximumChat={showMaximumChat}
                            {...props}
                        />
                        {selectedOptions[1] && (
                            <>
                                <div className="error-line"></div>
                                <SectionTwo handleButtonClick={handleButtonClick} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} toggleOption={toggleOption} data={props?.item?.text}
                                    {...props} />
                            </>
                        )}
                        {selectedOptions[2] && (
                            <>
                                <div className="error-line"></div>
                                <SectionThree handleButtonClick={handleButtonClick} setSelectedOptions={setSelectedOptions} selectedOptions={selectedOptions} toggleOption={toggleOption} data={props?.item?.text}
                                    {...props} />
                            </>
                        )}
                        {selectedOptions[3] && (
                            <>
                                <div className="error-line"></div>
                                {/* {getSectionFour()} */}
                                <SectionFour
                                    handleButtonClick={handleButtonClick}
                                    setSelectedOptions={setSelectedOptions}
                                    selectedOptions={selectedOptions}
                                    toggleOption={toggleOption}
                                    data={data}
                                    {...props}
                                />
                            </>
                        )}
                        {selectedOptions[4] && (
                            <>
                                <div className="error-line"></div>
                                {/* {getSectionFive()} */}
                                <SectionFive
                                    handleButtonClick={handleButtonClick}
                                    setSelectedOptions={setSelectedOptions}
                                    selectedOptions={selectedOptions}
                                    toggleOption={toggleOption}
                                    data={data}
                                    {...props}
                                />
                            </>
                        )}
                        {selectedOptions[5] && (
                            <>
                                <div className="error-line"></div>
                                {/* {getSectionSix()} */}
                                <SectionSix
                                    handleButtonClick={handleButtonClick}
                                    setSelectedOptions={setSelectedOptions}
                                    selectedOptions={selectedOptions}
                                    toggleOption={toggleOption}
                                    data={data}
                                    {...props}
                                />
                            </>
                        )}
                        {/* Add more sections in the same pattern */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessageA9T;
